import React, {useEffect, useState} from "react";

import Table from "../../common/Table";
import calc from "../../../utils/calculation";
import lbl from "../../../data/Labels.json";

const BenefitsList = ({ data }) => {

  const payablesColumns = [
    {path: "id", label: "شماره"},
    {path: "verification_date", label: "تاریخ",},
    {path: "verified_by_staff_name", label: "تایید کننده"},
    {path: "modified_by_staff_name", label: "ثبت کننده"},
    {path: "remark", label: "ملاحظه"},
    {path: "amount", label: "قابل پرداخت"},
  ];

  const summary = {
    "present_count": calc.getTotal(data, "present_count"),
    "absent_count": calc.getTotal(data, "absent_count"),
    "holiday_count": calc.getTotal(data, "holiday_count"),
    "salary_per_month": calc.getTotal(data, "salary_per_month"),
    "absent_cut": calc.getTotal(data, "absent_cut"),
    "salary_tax":  calc.getTotal(data, "salary_tax"),
    "amount": calc.getTotal(data, "amount"),
  }


  return (
  <div className="print-table-area">
    <Table
        data={{data, summary}}
        columns={payablesColumns}
    />
  </div>
  );
};

export default BenefitsList;
